import CounterpartyModel from "./CounterpartyModel";
import VehicleModel from "./VehicleModel";

export default class Vehicle {
	constructor(data?: any) {
		if (data) {
			this.id = data.id ?? 0;
			this.date = data.date ?? new Date(1970, 0, 1);
			
			this.vin = data.vin;
			this.govermentalNumber = data.govermentalNumber;
			this.ownerChanged = data.ownerChanged == true;
			this.mileage = data.mileage;
			
			if (data.productionDate) {
				this.productionDate = new Date(data.productionDate);
			}

			if (data.engine) {
				this.engine = data.engine;
			}

			if (data.modelYear) {
				this.modelYear = data.modelYear;
			}

			if (data.transmission) {
				this.transmission = data.transmission;
			}
			
			if (data.model?.id) {
				this.model = new VehicleModel(data.model);
			}

			if (data.counterparty?.id) {
				this.counterparty = new CounterpartyModel(data.counterparty);
			}			
		}
	}

	id = 0;
	date = new Date(1970, 0, 1);
	vin = '';
	govermentalNumber: string | null = null;
	mileage = 0;
	ownerChanged = false;
	model: VehicleModel | null = null;
	counterparty: CounterpartyModel | null = null;
	engine: string | null = null;
	modelYear: number | null = null;
	transmission: string | null = null;
	productionDate: Date | null = null;
}
